export const formatQualityReportCount = (value: number | null | undefined): string => {
  if (value == null || value === 0) {
    return '-';
  }
  return String(value);
};

export const formatQualityReportAverage = (value: number | null | undefined): string => {
  if (value == null) {
    return '-';
  }
  return value.toFixed(2);
};
